// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "20260924.1790280985/static/js/" + chunkId + "." + {"249":"5e7e85b5","463":"8a875d0b"}[chunkId] + ".chunk.js";
};